enum RecordPaneTab {
  DETAILS = "details",
  ACTIVITIES = "activities",
  RELATIONSHIPS = "relationships",
  NOTES = "notes",
  FILES = "files",
  EMAILS = "emails",
}

export default RecordPaneTab;
